import React from 'react'
import './Demo3.css'
import { useNavigate } from 'react-router-dom';
export default function Demo3() {
    const navigate = useNavigate(); // Initialize useNavigate hook

    // Function to handle navigation
    const navigateHome = () => {
        navigate("/home");
    };
  return (
    <div>
       <div className="landing-container-custom-3">
                <div className="overlay-custom-3">
                  
                     <button className="explore-button-custom2" onClick={navigateHome}>
                        Explore
                    </button>
                </div>
            </div>
    </div>
  )
}
